import { useMutation } from 'react-query';
import {
  getAllHomeAssistantSchedulesByLicenseAsync,
  createHomeAssistantScheduleAsync,
  updateHomeAssistantScheduleAsync,
  deleteHomeAssistantScheduleAsync,
} from '../..';

export const useGetAllHomeAssistantSchedulesByLicenseAsync = () =>
  useMutation(getAllHomeAssistantSchedulesByLicenseAsync);

export const useCreateHomeAssistantScheduleAsync = () =>
  useMutation(createHomeAssistantScheduleAsync);

export const useUpdateHomeAssistantScheduleAsync = () =>
  useMutation(updateHomeAssistantScheduleAsync);

export const useDeleteHomeAssistantScheduleAsync = () =>
  useMutation(deleteHomeAssistantScheduleAsync);
